// 跨平台输入适配使用的系统类型。
export type PlatformKind = 'windows' | 'macos' | 'linux' | 'unknown';
export type ControllerInputMode = 'pointer' | 'touch';

export function normalizePlatform(value: unknown): PlatformKind {
  const raw = String(value || '').toLowerCase();
  if (raw.includes('darwin') || raw.includes('mac') || raw.includes('os x') || raw.includes('iphone') || raw.includes('ipad')) return 'macos';
  if (raw.includes('win')) return 'windows';
  if (raw.includes('linux') || raw.includes('x11') || raw.includes('ubuntu')) return 'linux';
  return 'unknown';
}

export function platformLabel(platform: PlatformKind | string | undefined): string {
  switch (normalizePlatform(platform)) {
    case 'windows':
      return 'Windows';
    case 'macos':
      return 'macOS';
    case 'linux':
      return 'Linux';
    default:
      return '未知系统';
  }
}

export function detectBrowserPlatform(): PlatformKind {
  if (typeof navigator === 'undefined') return 'unknown';
  const nav = navigator as Navigator & { userAgentData?: { platform?: string } };
  return normalizePlatform(nav.userAgentData?.platform || navigator.platform || navigator.userAgent);
}

// 触摸设备不适合绘制固定的桌面箭头；带有精确鼠标/触控板指针的控制端则使用
// 即时本地光标。优先看 CSS 指针能力，避免把“支持触摸的 PC”误判成手机。
export function detectBrowserInputMode(): ControllerInputMode {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return 'pointer';
  const coarse = window.matchMedia('(pointer: coarse)').matches;
  const hover = window.matchMedia('(hover: hover)').matches;
  return coarse && !hover ? 'touch' : 'pointer';
}
